import { render, staticRenderFns } from "./RequestFormsList.vue?vue&type=template&id=5f829fa0"
import script from "./RequestFormsList.vue?vue&type=script&lang=js"
export * from "./RequestFormsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports